import React, { useState } from "react";
import Header from "./HeaderThree";
import '../styles/ContactUsPage.css';

import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa6";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState({ submitting: false, success: false, error: null });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ submitting: true, success: false, error: null });

    const data = new FormData();
    Object.keys(formData).forEach(key => {
      data.append(key, formData[key]);
    });

    try {
      const response = await fetch("https://dezainally.com/vessella-backend/contact-vessella.php", {
        method: "POST",
        body: data
      });

      const result = await response.json();
      if (result.status === "success") {
        setStatus({ submitting: false, success: true, error: null });
        setFormData({ firstName: '', lastName: '', phone: '', email: '', message: '' }); // Reset form
      } else {
        setStatus({ submitting: false, success: false, error: result.message || "Submission failed" });
      }
    } catch (error) {
      console.error("Form submission error:", error);
      setStatus({ submitting: false, success: false, error: "Network error. Please try again later." });
    }
  };

  return (
    <>

      <section className="contact-section py-5">
        {/* <div className="hero-blue-overlay" /> */}

        <div className="container">
          <div className="row py-5">

            {/* LEFT SIDE */}
            <div className="col-md-5 left-animate">
              <h1 className="contact-title mb-5">Let’s Start a Conversation</h1>
              {/* <p className="contact-subtext geist-font">
              Select the reason for inquiry to access the appropriate form.
            </p> */}

              {/* <div className="linkedin-box mb-4">
              in
            </div> */}

              <div className="d-flex gap-3 mb-4">
                <a href="https://www.facebook.com/vessellagroup/" target="_blank" className="social-box" rel="noopener noreferrer">
                  <FaFacebookF />
                </a>
                <a href="https://www.instagram.com/vessellagroup/" target="_blank" className="social-box" rel="noopener noreferrer">
                  <FaInstagram />
                </a>
                <a href="https://in.linkedin.com/company/vessella-group" target="_blank" className="social-box" rel="noopener noreferrer">
                  <FaLinkedinIn />
                </a>
                <a href="https://www.youtube.com/@vessellagrouphyd" target="_blank" className="social-box" rel="noopener noreferrer">
                  <FaYoutube />
                </a>
              </div>



              <div className="investor-info mt-3">
                {/* <p className="mb-1 text-primary"> Contact</p> */}

                <p className="text-muted mb-1 geist-font">Head Office: <a href="tel:04023014498" className="text-muted text-decoration-none">040 23014498</a> / <a href="tel:04023014499" className="text-muted text-decoration-none">99</a></p>
                <p className="text-muted mb-1 geist-font">Marketing Ph: <a href="tel:+919121244421" className="text-muted text-decoration-none">9121244421</a> / <a href="tel:+919121244403" className="text-muted text-decoration-none">03</a></p>
                <p className="text-muted mb-1 geist-font">Fax: <a href="tel:04023014497" className="text-muted text-decoration-none">040 23014497</a></p>
                <p className="text-muted mb-1 geist-font">
                  Email:
                  <a
                    href="mailto:info@vessella.in"
                    className="text-primary geist-font email-link"
                  >
                    info@vessella.in
                  </a>
                </p>

                <p className="text-muted geist-font">
                  <a href="https://maps.google.com/?q=1st+Floor,+East+Block,+Cyber+Meadows,+Kondapur,+Hyderabad+-+500084.+T.S.+India" target="_blank" rel="noopener noreferrer" className="text-muted text-decoration-none hover-primary">1st Floor, East Block, Cyber Meadows, Kondapur,<br />
                  Hyderabad - 500 084. T.S. India.</a>
                </p>
              </div>


            </div>

            {/* RIGHT SIDE */}
            <div className="col-md-7 form-animate">

              {/* TABS */}
              {/* <div className="contact-tabs mb-4">
              <span className="active">INVESTORS</span>
              <span>SUPPLIERS</span>
              <span>EMPLOYMENT</span>
              <span>COMMUNITY</span>
            </div> */}

              {/* FORM */}
              {/* FORM */}
              <form onSubmit={handleSubmit}>
                <div className="row mb-4">
                  <div className="col">
                    <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} className="form-input" placeholder="First name *" required />
                  </div>
                  <div className="col">
                    <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} className="form-input" placeholder="Last name *" required />
                  </div>
                </div>

                <div className="row mb-4">
                  <div className="col">
                    <input type="tel" name="phone" value={formData.phone} onChange={handleChange} className="form-input" placeholder="Phone *" required />
                  </div>
                  <div className="col">
                    <input type="email" name="email" value={formData.email} onChange={handleChange} className="form-input" placeholder="Email *" required />
                  </div>
                </div>

                <div className="mb-4">
                  <textarea name="message" value={formData.message} onChange={handleChange} className="form-input" placeholder="Message" required></textarea>
                </div>

                {status.success && <div className="alert alert-success mt-3 mb-3">Message sent successfully!</div>}
                {status.error && <div className="alert alert-danger mt-3 mb-3">{status.error}</div>}

                <div className="d-flex align-items-center gap-2">
                  <button type="submit" className="btn submit-btn" disabled={status.submitting}>
                    {status.submitting ? "SUBMITTING..." : "SUBMIT"}
                  </button>
                  <button type="button" className="btn arrow-btn">»</button>
                </div>

                <p className="form-note mt-3 geist-font">
                  Complete all required fields to enable submission.
                </p>
              </form>

            </div>
          </div>
        </div>


      </section>
    </>

  );
};

export default ContactUs;
